import React from 'react';
import { Handle, Position } from 'reactflow';
import { Box } from '@mui/material';
import { CustomSparkStepNode } from './Custom';
import type { SparkStepNodesType } from '../types';

export type SparkStepNodeProps = {
  data: Extract<SparkStepNodesType, { data: any }>['data'];
};
export default React.memo(({ data }: SparkStepNodeProps) => {
  return (
    <>
      <Handle
        type='target'
        position={Position.Top}
        style={{ background: '#555', visibility: 'hidden' }}
      />
      <Box
        sx={{ display: 'flex', position: 'relative' }}
        className='spark_chart_node_container'
      >
        <CustomSparkStepNode data={data} />
      </Box>
      <Handle
        type='source'
        position={Position.Bottom}
        style={{ background: '#555', visibility: 'hidden', width: '20px' }}
      />
    </>
  );
});
